import React, { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'LuxKit/Typography/Heading'

import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useActiveAmenityFilters } from 'hooks/useActiveAmenityFilters'
import { reorderAmenitiesByActiveFilters } from 'lib/offer/amenitiesUtils'

const Categories = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${rem(2)} ${rem(16)};
  margin: ${rem(4)} 0 0 0;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(auto-fill, minmax(${rem(180)}, 1fr));
  }
`

const Category = styled.li`
  display: flex;
  align-items: center;
  margin: ${rem(4)} 0 0;

  & > svg {
    margin-right: ${rem(8)};
  }
`

const ViewAllButton = styled(TextButton)`
  margin: ${rem(16)} 0 0;
`

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
}

function BedbankPopularFacilities(props: Props) {
  const intl = useIntl()
  const activeAmenityFilters = useActiveAmenityFilters()

  const reorderedFacilities = useMemo(() => {
    // Reorder popularFacilities before rendering to boost matching amenities
    return activeAmenityFilters.size > 0
      ? reorderAmenitiesByActiveFilters(props.offer.popularFacilities, activeAmenityFilters)
      : props.offer.popularFacilities
  }, [props.offer.popularFacilities, activeAmenityFilters])

  return <div>
    <Heading variant="heading4" as="h4">
      {intl.formatMessage({
        id: 'jX/MwxAFPA',
        defaultMessage: 'Popular Facilities',
        description: 'Heading for popular facilities section on bedbank offer page',
      })}
    </Heading>
    <Categories>
      {reorderedFacilities.map((categoryName) => (
        <Category key={categoryName}>
          <LineCheckIcon size="S" />{categoryName}
        </Category>
      ))}
    </Categories>
    <ViewAllButton horizontalOutdent="start" kind="tertiary" href="#facilities-all">
      {intl.formatMessage({
        id: 'EzQKrLOECt',
        defaultMessage: 'View all facilities',
        description: 'Button text to view all facilities on bedbank offer page',
      })}
    </ViewAllButton>
  </div>
}

export default memo(BedbankPopularFacilities)
